import React from 'react';
import { Button } from './ui/button';
import { ArrowDown } from 'lucide-react';

const Hero = () => {
  const scrollToEvents = () => {
    const element = document.getElementById('events');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToEnquiry = () => {
    const element = document.getElementById('enquiry');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
      aria-labelledby="hero-heading"
    >
      {/* Background Gradient - using darker green and subtle maroon */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-50 via-white to-orange-50/30" />
      
      {/* Decorative Elements - darker green */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-green-200/40 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-green-100/40 rounded-full blur-3xl" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-green-100/30 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        {/* Main Heading */}
        <h1 
          id="hero-heading"
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-6"
        >
          Celebrate Women.
          <br />
          <span className="text-green-800">
            Champion Inclusion.
          </span>
        </h1>

        {/* IWD Description */}
        <p className="text-lg sm:text-xl text-gray-700 max-w-3xl mx-auto mb-6 leading-relaxed">
          <strong>International Women's Day (IWD)</strong> is observed globally on <strong>8th March</strong> every year. 
          It's a day to recognize women's achievements, reflect on what needs to change for women to 
          thrive equitably at work, and create meaningful conversations about inclusion, safety, and equal opportunity.
        </p>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto mb-10 leading-relaxed">
          Explore our curated bouquet of IWD engagement experiences - from reflective dialogues 
          and skill-building workshops to inspiring performances - designed to create 
          lasting impact in your organization.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <Button
            onClick={scrollToEvents}
            size="lg"
            className="bg-green-800 hover:bg-green-900 text-white px-10 py-7 text-lg font-bold shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 hover:scale-105 w-full sm:w-auto rounded-xl"
          >
            Explore Events
          </Button>
          <Button
            onClick={scrollToEnquiry}
            variant="outline"
            size="lg"
            className="border-2 border-green-800 text-green-800 hover:bg-green-50 hover:border-green-900 px-10 py-7 text-lg font-bold w-full sm:w-auto rounded-xl transition-all hover:scale-105"
          >
            Send Enquiry
          </Button>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <button
            onClick={scrollToEvents}
            className="p-3 text-green-800 hover:text-green-900 focus:outline-none focus:ring-2 focus:ring-green-500 rounded-full bg-white/80 shadow-lg hover:shadow-xl transition-all"
            aria-label="Scroll to events"
          >
            <ArrowDown className="w-6 h-6" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
